import { FC } from 'react';

import { TableColumn } from 'constants/shared/table.constants';

interface Props {
  columns: TableColumn[];
}

export const SkeletonTableRow: FC<Props> = ({ columns }) => {
  return (
    <>
      {[...Array(10)].map((_, index) => (
        <tr key={index}>
          {columns.map(({ id }) => (
            <td className='is-loading' key={id}>
              <div className='m-0.5' />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};
